import { TELEMEDICINE_REQUEST_HEADER_TITLES } from './telemedicineRequestHeaderTitles';

export { TELEMEDICINE_REQUEST_HEADER_TITLES };
